import { createFileRoute } from "@tanstack/react-router";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { ImageIcon } from "lucide-react";

export const Route = createFileRoute("/integration/imaging")({
  component: ImagingGateway,
});

function ImagingGateway() {
  return (
    <div className="space-y-4 p-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
          <ImageIcon className="h-5 w-5" /> Imagerie PACS
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">Orthanc · dcm4chee · DICOM Q/R</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Passerelle imagerie</CardTitle>
          <CardDescription>Module de routage DICOM ↔ dossiers patients</CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          Statistiques temps réel : /api/imaging/orthanc/stats · /api/imaging/dcm4chee/stats
        </CardContent>
      </Card>
    </div>
  );
}
